import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxEchartsModule } from 'ngx-echarts';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { TemplateFieldListSubDocModule } from 'src/app/generated/ui/listSubdoc/TemplateField/TemplateField.module';

import { NetworkGraphComponent } from './network-graph.component';

@NgModule({
  declarations: [NetworkGraphComponent],
  imports: [
    CommonModule,
    FurySharedModule,
    MatDialogModule,
    MatCardModule,
    MatFormFieldModule,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,

    MatInputModule,
    MatSelectModule,

    MatDatepickerModule,

    MatCheckboxModule,

    MatExpansionModule,

    TemplateFieldListSubDocModule,
    MatDialogModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,

    TemplateFieldListSubDocModule,

    FurySharedModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') })
  ]
})
export class NetworkGraphModule {}
